import { render, staticRenderFns } from "./TabUpVacation.vue?vue&type=template&id=39cf248c&"
import script from "./TabUpVacation.vue?vue&type=script&lang=js&"
export * from "./TabUpVacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports